import React from 'react'
import Container from '@material-ui/core/Container'
import styleClasses from '../components/common/common.module.scss'
import ReportForm from '../components/reservationsReport/ReportForm'

export default function ReservationsReportPage() {
  return (
    <main className={styleClasses.content}>
      <Container maxWidth="lg" className={styleClasses.container}>
        <ReportForm />
      </Container>
    </main>
  )
}
